import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { purposeData } from '../../@types/purposeData';
import URLConstants from 'constants/urlConstants';

type PurposeState = {
    isLoading: boolean;
    error: boolean;
    purposeValues: purposeData[];
}

const initialState: PurposeState = {
    isLoading: false,
    error: false,
    purposeValues: [],
}

const slice = createSlice({
    name: 'purposeValues',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET PURPOSE
        getPurposeSuccess(state, action) {
            state.isLoading = false;
            state.purposeValues = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getPurpose() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.PURPOSE_BASE_URL);
        dispatch(slice.actions.getPurposeSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }